// LPR (Lost Policy Release) service. Thin wrappers over /api/lpr/* —
// these endpoints live OUTSIDE /api/tracon/* per the SNKL/BR doc-type
// signing primitive convention. Backend: routes/lpr.routes.js (Phases
// 1+2 already shipped).
//
// Three paths the broker wizard uses:
//   draftLpr(dealId, inputs)     → POST /api/lpr/deal/:id/draft
//   dispatchLpr(dealId, inputs)  → POST /api/lpr/deal/:id/dispatch
//   previewLprPdf(dealId, inputs)→ POST /api/lpr/deal/:id/preview returning a Blob

import { api } from '@/lib/api.js';

export function draftLpr(dealId, inputs) {
  return api.post(`/api/lpr/deal/${encodeURIComponent(dealId)}/draft`, inputs);
}

export function dispatchLpr(dealId, inputs) {
  return api.post(`/api/lpr/deal/${encodeURIComponent(dealId)}/dispatch`, inputs);
}

// Blob fetch — bypasses api.post() because that helper assumes JSON
// response bodies. The server returns application/pdf here. Auth + 401
// handling deliberately mirrors apiCall() in lib/api.js so a stale JWT
// during preview rendering still triggers the global auth:expired
// listener instead of silently failing the iframe.
export async function previewLprPdf(dealId, inputs) {
  const token = localStorage.getItem('tracon_token');
  const res = await fetch(`/api/lpr/deal/${encodeURIComponent(dealId)}/preview`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(inputs),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    if (res.status === 401 && body?.error) {
      window.dispatchEvent(new Event('auth:expired'));
    }
    throw new Error(body?.error || `preview ${res.status}`);
  }
  return res.blob();
}
